<a href="#" (click)="openPlayerWindow($event)">
    <svg class="icon-20" style="fill: #007CBE;">
        <use href="../App_Themes/CXone/icons/play.svg#play"></use>
    </svg>
</a>